module.exports = __webpack_public_path__ + "img/pattern_02.6cb61c93.svg";